import React from 'react';
import slugify from 'slugify';

import useQuery from './utils/use-query';
import useDash from './utils/dash-api';
import faciltiesFilters from './utils/facilities-filters';
import qs from 'qs';

function stringToarray( arrayOnString ){    
    let temp = arrayOnString.replace(/\[/g, "");
    let temp2 = temp.replace(/]/g, "");
    return temp2.split(','); 
}

function validFacilities( filters ){
    
    return  item =>{

        let facilities = item.relationships.facilities || "[]";
        let facilityName_array = item.relationships.facility_name || "[]";
        let facility_season = item.relationships.facility_season || "[]"; //Array with the relationship between facility and season
        let facility_dow = item.relationships.facility_dow || "[]"; //Array with the relationship between facility and Day of the week
        let facility_timeofday = item.relationships.facility_timeofday || "[]"; //Array with the relationship between facility and Day of the week

        facilities = stringToarray(facilities);    
        facilityName_array =  JSON.parse(facilityName_array.replace(/\'/g, "\""));  
        facility_season  = JSON.parse( facility_season.replace(/\'/g, "\"") );
        facility_dow  =  JSON.parse( facility_dow.replace(/\'/g, "\"") );
        facility_timeofday = JSON.parse( facility_timeofday.replace(/\'/g, "\"") );


        let valid_facilties = faciltiesFilters( filters, facilities, facility_season, facility_dow, facility_timeofday ); 

        item.relationships['valid_facilities'] = facilityName_array.filter( ({ id,name }) => {
            return valid_facilties.includes( id );
        });
        
        return  valid_facilties.length ;

    }
}

function FacilityTag( { facilityName_array} ){   

    return (
        <div>
             {facilityName_array.map( ({id,name})=> <p className="intro-text location">{name}</p> )}
        </div>
    )
}

function ResultCard ({
    facility_id,
    id,
    info,
    name,
    program_id,
    program_type_id,
    skill_level,
    image_url,
    sportname,
    valid_facilities,
    filters,
    type,
    url,
    dow,
    reglink
}) {
    

    const defaultImage = `${window.location.origin}/themes/theme/images/bucket-placeholder.jpg`;
    const imageUrl = image_url || defaultImage;
    const skillLevel = window.SKILL_LEVELS[type][skill_level] || 'Unknown';
    const validFacilityName = valid_facilities || [];

    
    //cloning filters and preparing them as URL params
    let single_activity_filters = { 'location':filters['location'],'dow':filters['dow'],'time':filters['time'],'season':filters['season'] } ;

    if (sportname) {
        var slink = slugify(sportname, { lower: true, });
        slink = slink.replace(/\(/g, "");
        slink = slink.replace(/\)/g, "");
        slink = '/activities/'+slink+'/'+slugify(name, { lower: true, })+'?leagueid='+id+'&'+qs.stringify( single_activity_filters );
    }
    if (reglink) {
        slink = reglink;
    }
    var link = slink || '';
    var ptype = "Programs";
    if (type === "camp") {
        ptype = "Camps";
    } else if (type === "league") {
        ptype = "Leagues";
    }
    else if (type === "dropins") {
        ptype = "Drop-Ins";
    }
    else if (type === "tournaments") {
        ptype = "Tournaments";
    }

    return (
        
            <div className="card">
                {name != 'Level Up' &&
                    <a href={link}>
                    <div className={`level level-${slugify(skillLevel, { lower: true, })}`}>{skillLevel}</div>
                    <div
                        className="card-image bg-image lazy"
                        style={{
                            backgroundImage: `url(${imageUrl})`,
                        }}
                    />
                    <p className="intro-text">{sportname} {ptype}</p>
                    <h3>{name}</h3>
                    <FacilityTag 
                        facilityName_array={validFacilityName}              
                    />
                    <p
                        className="description"
                        dangerouslySetInnerHTML={{
                            __html: info,
                        }}
                    />
                    <span
                        href={link}
                        className="btn btn-slide"
                        title="Learn More"
                    >
                        Learn More
                    </span>
                    </a>
                }
                {name == 'Level Up' &&
                    <span>
                    <div className={`level level-${slugify(skillLevel, { lower: true, })}`}>NEW FOR BEGINNERS!</div>
                    <div
                        className="card-image bg-image lazy"
                        style={{
                            backgroundImage: `url(${imageUrl})`,
                        }}
                    />
                    <p className="intro-text">{sportname} {ptype}</p>
                    <h3>{name}</h3>
                    <FacilityTag 
                        facilityName_array={validFacilityName}              
                    />
                    <p
                        className="description"
                        dangerouslySetInnerHTML={{
                            __html: info,
                        }}
                    />
                    <a
                        href={link}
                        className="btn btn-slide noslide"
                        title="Learn More"
                    >
                        Learn More
                    </a><br></br><br></br>
                    {/* <a
                        href="/levelup/"
                        className="btn btn-slide noslide navy"
                        title="Learn More"
                    ></a> */}
                    </span>
                }
            </div>
        
    );
}


export default function () {
    const [ filters, ] = useQuery();
    let data = window.PROGRAM_META;

    if (window.newData){    
        data = window.newData.data.program_meta;
    }

    let results = useDash(filters, data);

    if (typeof filters.type === 'undefined') {
        filters.type = 'programs';
    }

    results = results.filter( validFacilities( filters ) );
    if (results.length === 0) {
        return (
            <section id="result-cards" className="result-cards">
                <div className="container">
                    <div className="card-container">
                        <div className="nofind">
                            <h3>Sorry, no results that match your search are available at this time.<br />Please check back soon or <a href="/activities/" title="Reset Filters">reset filters</a>.</h3>
                        </div> 
                    </div>
                </div>
            </section>
        )
    } else {
        return (
            <section id="result-cards" className="result-cards">
                <div className="container">
                    {/* <div className="result-header">
                        <p>Results found: {results.length}</p>
                    </div> */}

                    <div className="card-container">
                    {results.map(({ id,type,attributes,relationships }) =>
                        <ResultCard
                            id={id}
                            filters= {filters} 
                            type={type}
                            {...attributes}
                            {...relationships}

                        />
                    )}
                    </div>
                </div>
            </section>
        )
    }
}

// https://apps.dashplatform.com/test3/dash/${id}

